// John Eldhose 201800606
import { RestfulGet } from './Restful';

export async function getContact() {
  const con = await RestfulGet('getContact', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return con;
}



// WEBPACK FOOTER //
// ./src/Api/getContact.js